import { render, staticRenderFns } from "./OrgPaymentProviderSettings.vue?vue&type=template&id=0bf8b46e&"
import script from "./OrgPaymentProviderSettings.vue?vue&type=script&lang=js&"
export * from "./OrgPaymentProviderSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports